import type { TelegramRecipient } from "../../common/requests/notifications/endpoints";
import type { BroadcastHistoryEntry } from "../../common/requests/activity/endpoints";
import type { Tone } from "../../ui";

export const TELEGRAM_LIMIT = 4096;

export const recipientLabel = (u: TelegramRecipient) => u.username || u.email || u.user_id;

export const splitRecipients = (all: TelegramRecipient[]) => ({
  sellers: all.filter((r) => r.is_seller),
  buyers: all.filter((r) => !r.is_seller),
});

/** Why the message can't be sent yet, or null when it can. */
export function messageError(recipientCount: number, trimmedMessage: string): string | null {
  if (recipientCount === 0) return "Pick at least one recipient.";
  if (!trimmedMessage) return "Write a message.";
  if (trimmedMessage.length > TELEGRAM_LIMIT) return `Too long: Telegram allows ${TELEGRAM_LIMIT} characters.`;
  return null;
}

export function deliveryTone(h: Pick<BroadcastHistoryEntry, "sent" | "failed">): Tone {
  if (h.failed && !h.sent) return "danger";
  if (h.failed) return "warning";
  return "success";
}
